import { createSelector } from 'reselect'

const getState = state => state.ui

export const getIsShowLoading = createSelector(
	getState,
	state => state.isShowLoading,
)
export const getAlert = createSelector(getState, state => state.alert)
